import { useEffect } from 'react';

import { useFormikForm } from '#/common/hooks';
import { chatbotInputSchema } from '#/utils/ValidationSchema';

export function useChatbotPreview(
  updateMessages,
  resetFaqId,
  contentRef,
  isFieldSubmit,
  setIsFieldSubmit,
  setUploadedFiles
) {
  const initialValues = { inputField: '' };

  const onSubmit = values => {
    if (!values.inputField.trim()) return;
    updateMessages(values.inputField);
    resetForm();
    resetFaqId('');
    setUploadedFiles({});
  };

  const {
    values: { inputField },
    handleChange,
    submitForm,
    resetForm,
  } = useFormikForm(initialValues, onSubmit, chatbotInputSchema);

  const handleEnterKeyPress = e => {
    if (e.key === 'Enter' && inputField.trim()) {
      e.preventDefault();
      submitForm();
    }
  };

  const scrollToBottom = () => {
    setTimeout(() => {
      if (contentRef.current) {
        contentRef.current.scrollTop = contentRef.current.scrollHeight;
      }
    }, 0);
  };

  const handlePreviewToggle = () => {
    resetForm();
    resetFaqId('');
    setIsFieldSubmit(!isFieldSubmit);
    setUploadedFiles({});
    scrollToBottom();
  };

  useEffect(() => {
    const handleShowPreview = event => {
      const { action, value } = event.data || {};
      if (action === 'showWidgetPreviewChange') {
        if (value) {
          handlePreviewToggle();
        }
      }
    };

    window.addEventListener('message', handleShowPreview);
    return () => window.removeEventListener('message', handleShowPreview);
  }, []);

  return {
    handlePreviewToggle,
    inputField,
    handleChange,
    handleEnterKeyPress,
    submitForm,
  };
}
